<template>
    <div id="hotActive">
        <div class="titleBox clearfix">
          <div class="left fl">
            热门活动
          </div>
          <a class="change fr" :href="navsObj.activity_url" target="_blank">查看更多</a>
        </div>
        <div class="list_box">
            <div class="list clearfix" v-for="(item,index) in activitys" v-if="index<5" :key="item.tid">
              <router-link :to="{path:`/newsdetail/${item.tid}`}" target="_blank">
                <div class="left">
                    <img :src="item.thumb" alt="">
                </div>
                <div class="right">
                    <p class="subject">{{item.subject}}</p>
                    <div class="price">
                      价格：<span class="red">{{item.price}}</span>元起
                    </div>
                </div>
              </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import service from "@/api/service/service";
export default {
  props: ["streetId",'url','activitys','sid'],
  data() {
    return {
      list: [],
      navsObj: JSON.parse(localStorage.getItem("navsObj")),
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
#hotActive {
  margin: 15px 0;
  padding:15px;
  border-radius:5px;
  background: #f8f8f8;
  .titleBox {
    line-height: 22px;
    margin:0 0 20px 0;
    .left {
      color: @c3;
      font-size: @ft20;
      position: relative;
      &::before{
        width: 5px;
        height: 20px;
        display: inline-block;
        top:2px;
        content:'';
        left:-15px;
        background: #fa9d08;
        position: absolute;
      }
    }
    .change {
      color: @c9;
      font-size: @ft16;
      padding:0 15px 0 21px;
      background: url("~@/assets/imgs/ra.png") no-repeat right center;
      background-size: 12px;
    }
  }
  h3 {
    a {
      color: #000;
      &:hover {
        color: #2d8ed9;
      }
    }
  }
  .list_box {
    .list {
      cursor: pointer;
      margin:0 0 20px 0;
      &:last-child{
        margin-bottom:0;
      }
      .left {
        margin: 0 10px 0 0;
        width: 128px;
        height: 83px;
        text-align: center;
        overflow: hidden;
        .fl();
        img {
          width: 100%;
          height: 100%;
          border-radius:3px;
          object-fit: cover;
          vertical-align: middle;
        }
      }
      .right {
        .fl();
        color: @c3;
        width: 150px;
        font-size: @ft16;
        .subject{
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
        .price{
          margin:21px 0 0;
          color:@c9;
          font-size:@ft14;
          .red{
            font-size:@ft14;
            color:@hred;
          }
        }
        &:hover {
          color: #2d8ed9;
        }
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Hotactive.vue